async function savePetData(petData) {
  try {
    // Get token from meta tag - update to match getPetData
    const customerToken = document.querySelector('meta[name="shopify-customer-token"]')?.content;
    console.log('Customer token:', customerToken); // Debug log

    if (!customerToken) {
      throw new Error('No customer token found');
    }

    const response = await fetch('/api/metafields', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${customerToken}`
      },
      body: JSON.stringify({
        customer_id: window.customer?.id,  // Use the global customer object like getPetData
        metafield: {
          namespace: 'custom',
          key: 'pet_data',
          value: JSON.stringify(petData),
          type: 'json'
        }
      })
    });

    console.log('Response status:', response.status); // Debug log
    
    if (!response.ok) {
      const error = await response.json();
      console.error('Error response:', error); // Debug log
      throw new Error(error.message || 'Failed to save pet data');
    }

    return await response.json();
  } catch (error) {
    console.error('Error saving pet:', error);
    throw error;
  }
}

// Similar update for getPetData function
async function getPetData() {
  try {
    const customerToken = document.querySelector('meta[name="shopify-customer-token"]')?.content;
    
    if (!customerToken) {
      throw new Error('No customer token found');
    }

    const response = await fetch(`${API_URL}/api/metafields?customer_id=${window.customer?.id}`, {
      headers: {
        'Authorization': `Bearer ${customerToken}`
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch pet data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching pets:', error);
    throw error;
  }
} 